/**
 * Complete list of countries using world-countries package
 * Sorted alphabetically with Arabic translations
 */
import worldCountries from 'world-countries';

// Priority countries shown at top (common for Wassla users)
const PRIORITY_COUNTRIES = ['SD', 'SA', 'AE', 'EG', 'QA', 'KW', 'BH', 'OM', 'JO', 'LB'];

// Build complete country list with English and Arabic names
const allCountries = worldCountries.map((c) => ({
  code: c.cca2,
  name_en: c.name.common,
  name_ar: c.translations?.ara?.common || c.name.common,
  region: c.region,
  subregion: c.subregion,
  dial: c.idd?.root
    ? c.idd.root + (c.idd.suffixes && c.idd.suffixes.length === 1 ? c.idd.suffixes[0] : '')
    : '',
}));

// Sort alphabetically by English name
const sortedCountries = allCountries.sort((a, b) => 
  a.name_en.localeCompare(b.name_en)
);

// Create final list: priority countries first, then rest
const priorityList = PRIORITY_COUNTRIES.map(code => 
  allCountries.find(c => c.code === code)
).filter(Boolean);

const otherCountries = sortedCountries.filter(
  c => !PRIORITY_COUNTRIES.includes(c.code)
);

export const COUNTRIES = [...priorityList, ...otherCountries];

// Export just the options for dropdowns
export const COUNTRY_OPTIONS = COUNTRIES.map(c => ({
  value: c.code,
  labelEn: c.name_en,
  labelAr: c.name_ar,
}));

// Sudan states for when Sudan is selected
export const SUDAN_STATES = [
  { key: 'khartoum', name_en: 'Khartoum', name_ar: 'الخرطوم' },
  { key: 'omdurman', name_en: 'Omdurman', name_ar: 'أم درمان' },
  { key: 'bahri', name_en: 'Bahri', name_ar: 'بحري' },
  { key: 'gezira', name_en: 'Gezira', name_ar: 'الجزيرة' },
  { key: 'kassala', name_en: 'Kassala', name_ar: 'كسلا' },
  { key: 'port_sudan', name_en: 'Port Sudan', name_ar: 'بورتسودان' },
  { key: 'north_darfur', name_en: 'North Darfur', name_ar: 'شمال دارفور' },
  { key: 'south_darfur', name_en: 'South Darfur', name_ar: 'جنوب دارفور' },
  { key: 'west_darfur', name_en: 'West Darfur', name_ar: 'غرب دارفور' },
  { key: 'east_darfur', name_en: 'East Darfur', name_ar: 'شرق دارفور' },
  { key: 'central_darfur', name_en: 'Central Darfur', name_ar: 'وسط دارفور' },
  { key: 'north_kordofan', name_en: 'North Kordofan', name_ar: 'شمال كردفان' },
  { key: 'south_kordofan', name_en: 'South Kordofan', name_ar: 'جنوب كردفان' },
  { key: 'west_kordofan', name_en: 'West Kordofan', name_ar: 'غرب كردفان' },
  { key: 'blue_nile', name_en: 'Blue Nile', name_ar: 'النيل الأزرق' },
  { key: 'white_nile', name_en: 'White Nile', name_ar: 'النيل الأبيض' },
  { key: 'sennar', name_en: 'Sennar', name_ar: 'سنار' },
  { key: 'red_sea', name_en: 'Red Sea', name_ar: 'البحر الأحمر' },
  { key: 'river_nile', name_en: 'River Nile', name_ar: 'نهر النيل' },
  { key: 'northern', name_en: 'Northern', name_ar: 'الشمالية' },
  { key: 'gedaref', name_en: 'Gedaref', name_ar: 'القضارف' }
];

export default COUNTRIES;
